import { routes } from 'types/routes.ts'
import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { useTranslation } from 'react-i18next'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetProducerContactQuery } from 'store/queries/cms-api'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton.tsx'
import { isWeekend } from 'utils/date.ts'
import { PhoneAvailability } from 'pages/app/support/contact/components/phone-availibility/PhoneAvailability.tsx'
import { selectCurrentAccount, selectIsProducerAccount } from 'store/contact/slice.ts'
import { zoomOnFace } from 'utils/cloudinary.ts'

const SupportOverviewCard = () => {
  // Redux store
  const isProducer = useStoreSelector(selectIsProducerAccount)
  const selectedAccount = useStoreSelector(selectCurrentAccount)

  // Redux Queries
  const { data, isLoading } = useGetProducerContactQuery({ contactId: selectedAccount.ownerId || '' }, { skip: !isProducer })

  // i18n
  const { t } = useTranslation('overview')

  // Constants
  const showProducerInfo = isProducer && !!data?.contact
  const translationKey = showProducerInfo ? 'producer' : 'consumer'

  if (isProducer && !data?.contact && !isLoading) {
    return null
  }

  return (
    <OverviewCard
      button={{ label: t(($) => $.contact.button[translationKey]), href: routes.SUPPORT_CONTACT }}
      image={
        isProducer && !data?.contact?.avatar
          ? undefined
          : {
              src:
                isProducer && data?.contact?.avatar
                  ? zoomOnFace(data?.contact.avatar.url)
                  : 'https://res.cloudinary.com/bolt-energie/image/upload/v1705664314/website/common/customer-care.png',
              alt: isProducer && data?.contact ? data.contact.firstName : 'customer-care'
            }
      }
      isLoading={isLoading}
    >
      {isLoading ? (
        <>
          <LoadingSkeleton.Title />
          <LoadingSkeleton.Paragraph lines={2} />
        </>
      ) : (
        <>
          <OverviewCard.Title>
            {t(($) => $.contact.title[translationKey], {
              name: data?.contact.firstName
            })}
          </OverviewCard.Title>
          <p>
            {showProducerInfo ? (
              t(($) => $.contact.description.producer[!isWeekend() ? 'available' : 'unavailable'])
            ) : (
              <PhoneAvailability />
            )}
          </p>
        </>
      )}
    </OverviewCard>
  )
}

export default SupportOverviewCard
